import React,{useState, useEffect} from "react";
import difference from "lodash/difference";
import { Button, Table, Transfer } from "antd";
import {useRequest} from "ahooks";
import {uniqBy} from "lodash";
import { TablePaginationConfig } from "antd/lib/table/interface";
import { DeleteOutlined } from "@ant-design/icons";
import {apiGetOrganizationPeople} from "@/services/exam_signup";
import {TOrganizationPeople} from "@/types/exam_signup";

type TTableTransfer = {
  certId: string;
  targetKeys: any[];
  setTargetKeys:(keys:any[]) => void;
}

const TableTransfer:React.FC<TTableTransfer> = (props) => {
  const {targetKeys,certId, setTargetKeys} = props;
  const [state, setState] = useState<{
    dataSource: TOrganizationPeople[],
    totalDataSource: TOrganizationPeople[],
    pagination: {
      current?: number,
      pageSize: number,
      total: number,
      showSizeChanger: boolean
    },
  }>({
    dataSource: [],
    totalDataSource: [],
    pagination: {
      current: 1,
      pageSize: 10,
      total: 0,
      showSizeChanger: false,
    },
  })
  const [searchValue, setSearchValue] = useState<string>('');
  const {run,loading} = useRequest((current,search=undefined) => {
    if (search){
      return apiGetOrganizationPeople(certId,current,search)
    }
    return apiGetOrganizationPeople(certId,current)
  },{
    manual: true,
    onSuccess:(res) => {
      console.log('获得数据是');
      console.log(res);
      if (res.code === 200){
        const result = res.data.list;
        setState(prevState => (
          {
            ...prevState,
            pagination:{...state.pagination,total: res.data.total},
            dataSource: uniqBy(result,'id').map(item => ({...item,disabled: !item.isSignup,name:item.realname !== null ? item.realname : item.username})),
            totalDataSource:uniqBy(state.totalDataSource.concat(result),'id').map(item => ({...item,disabled: !item.isSignup,name:item.realname !== null ? item.realname : item.username}))
          }));
      }
    }
  })
  useEffect(() => {
    if (certId){
      run(1);
    }
  }, [certId]);

  return (
    <Transfer
      showSelectAll={false}
      oneWay
      {...props}
      showSearch
      titles={['全部人员', '考试人员']}
      filterOption={(inputValue, item) =>
        item.name.indexOf(inputValue) !== -1
      }
      dataSource={state.dataSource}
      onSearch={async(direction, value) => {
        if(direction === 'left') {
          await run(state.pagination.current,value);
        }else {
          setSearchValue(value)
        }
      }}
      rowKey={(record) => String(record.id)}
      selectedKeys={targetKeys}
      selectAllLabels={[
        () => (
            <span>{state.totalDataSource.length} 项</span>
        ),
        () => (
            <span>{targetKeys.length} 项</span>
        )
      ]}
    >
      {({
          direction,
          onItemSelectAll,
          onItemSelect,
          onItemRemove,
          selectedKeys: listSelectedKeys,
          disabled: listDisabled
        }) => {
        const rowSelection = {
          getCheckboxProps: (item: { disabled: any; }) => ({
            disabled: listDisabled || item.disabled
          }),
          onSelectAll(selected: boolean, selectedRows: any[]) {
            const treeSelectedKeys = selectedRows
              .filter((item) => item && !item.disabled)
              .map(({ id }) => id);
            const diffKeys = selected
              ? difference(treeSelectedKeys, listSelectedKeys)
              : difference(listSelectedKeys, treeSelectedKeys);
            onItemSelectAll(diffKeys, selected);
            if (selected) {
              setTargetKeys([...targetKeys,...diffKeys]);
            } else {
              setTargetKeys(targetKeys.filter((item) => !diffKeys.includes(item)));
            }
          },
          onSelect({ id }: any, selected: boolean) {
            onItemSelect(id, selected);
            if(selected) {
              setTargetKeys([...targetKeys,id]);
            }else {
              setTargetKeys(targetKeys.filter((item) => item !== id))
            }
          },
          selectedRowKeys: targetKeys
        };

        const handleTableChange = async (paginationObj: TablePaginationConfig) => {
          console.log('onchange');
          console.log(paginationObj);
          if (paginationObj.current && direction === "left") {
            // @ts-ignore
            setState(prevState => ({...prevState,pagination: {...paginationObj,current: paginationObj.current}}))
            await run(paginationObj.current);
          }
        };

        const rightDataSource = state.totalDataSource
            .filter((item: { id: any; }) => targetKeys.includes(item.id))
            .filter((item: {realname:string}) => item.realname.includes(searchValue));

        const leftDataSource = state.dataSource.map((item: { id: any; isSignup:boolean, realname: string }) => ({
          ...item,
          disabled: !item.isSignup || item.realname == null
        }));

        const columns= [
          {
            dataIndex: "name",
            title: "姓名/用户名",
            width: 136
          },
          {
            dataIndex: "mobile",
            title: "手机号",
            width: 136
          },
        ]
        if(direction === "right" ) {
          columns.push({
            dataIndex: "operation",
            render: (text, record) => {
              return (
                  <>
                    <Button style={{float:"right",border:"none"}}
                        onClick={() => {
                          setTargetKeys(targetKeys.filter(item => item !== record.id))
                          onItemRemove?.([record.id])
                        }}
                        icon={<DeleteOutlined style={{fontSize:14,color:"#8D8D8D"}}/>
                    } />
                  </>
              )
            },
          })
        }

        return (
          <Table
            rowSelection={direction === "left" && rowSelection}
            columns={columns}
            loading={direction === "left" && loading}
            dataSource={
              direction === "left" ? leftDataSource : rightDataSource
            }
            size="small"
            rowKey="id"
            onRow={({ id, disabled: itemDisabled }) => ({
              onClick: () => {
                if (direction !== "left" ) return;
                if (itemDisabled) return;
                onItemSelect(id, !listSelectedKeys.includes(id));
              }
            })}
            onChange={handleTableChange}
            pagination={direction === 'left' ? state.pagination:false}
            scroll={{ y: 473 }}
          />
        );
      }}
    </Transfer>
  )
}
export default TableTransfer;
